import { SingleSelectField } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FilterOperator } from "./filterTypes";

interface Props {
	name: string;
	options: FilterOperator[];
	isCheckbox?: boolean;
}

export const FilterOperatorSelectField: FC<Props> = ({ name, options, isCheckbox }) => {
	const { t } = useTranslation();
	const [, , { setValue }] = useField(`${name}.value`);

	return (
		<SingleSelectField<FilterOperator, FilterOperator>
			options={options}
			label={t("Operator")}
			placeholder={t("Operator")}
			name={`${name}.operator`}
			getLabel={(option) => t(option)}
			clearable={false}
			onChange={(e) => setValue(e.target.value === "EQUAL" && isCheckbox ? false : null)}
		/>
	);
};
